// Portions ISC — Lucide Icons (https://lucide.dev/license). Full notice: @air/design-icons LICENSE.
// GENERATED — do not edit. Re-run `pnpm build:icons` or edit scripts/lib/generateIcons.js.
// Source: lucide-react@1.46.0 — SVG path data inlined at codegen.

import { type IconNode } from "../../../internal/iconNode";

export const iconNode = [
  ["circle", { cx: "12", cy: "12", r: "10" }],
  ["path", { d: "M12 6v6l4 2" }],
] as const satisfies IconNode;
